import React from 'react';

export default function SampleReport({ finalUserInfo, isPreview, onRunFullBattery, onGlossary }) {
  return (
    <>
      {/* Top-left action buttons (OUTSIDE main container) */}
      <div style={{ position: 'absolute', top: '1rem', left: '1rem', textAlign: 'left' }}>
        <button
          onClick={onRunFullBattery}
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#149854',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          🚀 Run Full Battery
        </button>

        <button
          onClick={onGlossary}
          style={{
            display: 'block',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          📘 Glossary
        </button>
      </div>

      {/* Centered report content */}
      <div style={{ 
        textAlign: 'center',
        padding: '5rem 2rem 6rem',
        maxWidth: '700px',
        margin: 'auto'
      }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>
          <span style={{ color: '#149854' }}>Cogello</span> Cognitive Report
        </h1>

        <hr style={{ margin: '2rem auto', maxWidth: '80%' }} />

        <Section
          title="Go/No-Go (Inhibition & Attention)"
          summary="48 correct out of 50. Avg RT: 450 ms"
          label="Within Expected"
          description="Strong inhibitory control and attentional consistency."
        />

        <Section
          title="1-Back (Working Memory)"
          summary="32 correct, 6 misses, 2 false alarms. Avg RT: 700 ms"
          label="Borderline"
          description="Mild working memory lapses or inconsistent attention."
        />

        <Section
          title="Stroop (Cognitive Control)"
          summary="24 correct. Avg RT: 650 ms"
          label="Below Expected"
          description="Likely impairment in interference control or cognitive flexibility."
        />

        <Section
          title="Trail Making (Processing Speed & Set-Shifting)"
          summary="Part A: 28s, 0 errors. Part B: 70s, 2 errors"
          label="Below Expected"
          description="Significant difficulty with processing speed and cognitive flexibility."
        />

        <Section
          title="PHQ-9 (Mood Screener)"
          summary="Total Score: 3, Severity: Minimal"
          label="Within Expected"
          description="No significant mood symptoms reported."
        />

        <hr style={{ margin: '3rem auto', maxWidth: '80%' }} />

        <p style={{ fontStyle: 'italic', fontSize: '0.95rem', maxWidth: '700px', margin: '0 auto' }}>
          This brief cognitive report is for screening purposes only. It is not a formal diagnosis.
        </p>
      </div>
    </>
  );
}

function Section({ title, summary, label, description }) {
  return (
    <div style={{ marginBottom: '2.5rem' }}>
      <h3 style={{ fontWeight: '600' }}>{title}</h3>
      <p style={{ margin: '0.25rem 0' }}>{summary}</p>
      <p style={{ fontWeight: 'bold', margin: '0.5rem 0' }}>{label}</p>
      <p style={{ fontStyle: 'italic', margin: 0 }}>{description}</p>
    </div>
  );
}
